import { Artwork, CreateArtworkRequestBody } from 'types';

export const getCreateArtworkFormInitialValues = (
  artwork: Artwork | null,
  companyId: number,
): CreateArtworkRequestBody & {
  imageMedia: File | string | null;
  videoMedia: File | string | null;
  iOSModel: File | string | null;
  androidModel: File | string | null;
} => {
  if (artwork) {
    return {
      name: artwork.name,
      slug: artwork.slug,
      triggeredQrcodeOnly: artwork.triggeredQrcodeOnly,
      isGuest: artwork.isGuest,
      pointerImage: artwork.pointerImage,
      qrcodeId: artwork.qrcodeId,
      qrcodeImagePng: artwork.qrcodeImagePng,
      qrcodeImageSvg: artwork.qrcodeImageSvg,
      imageMedia: artwork.type === 'image' ? artwork.media[0].url : null,
      videoMedia: artwork.type === 'video' ? artwork.media[0].url : null,
      iOSModel: artwork.type === '3d' ? artwork.media[0].url : null,
      androidModel: artwork.type === '3d' ? artwork.media[1].url : null,
      media: [],
      type: artwork.type,
      companyId,
    };
  }

  return {
    name: '',
    slug: null,
    triggeredQrcodeOnly: false,
    isGuest: false,
    pointerImage: null,
    qrcodeId: null,
    qrcodeImagePng: null,
    qrcodeImageSvg: null,
    imageMedia: null,
    videoMedia: null,
    iOSModel: null,
    androidModel: null,
    media: [],
    type: null,
    companyId,
  };
};
